import { render } from "./FormWrapper.vue?vue&type=template&id=09e0562a"
import script from "./FormWrapper.vue?vue&type=script&lang=js"
export * from "./FormWrapper.vue?vue&type=script&lang=js"

import "./FormWrapper.vue?vue&type=style&index=0&id=09e0562a&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__